import { get } from "@/util/http";
import axios from "axios";

function guestPost(path, params) {
	return axios.post(path, params, {
		headers: {
			'Content-Type': 'application/json'
		}
	}).then(res => res.data)
}

/**
 * Guest - 游客快速注册并保存地址
 */
export function guestRegister(params) {
	return guestPost('/upms/shop/guest/register', params)
}

/**
 * Guest - 检查邮箱是否已注册
 */
export function checkEmail(params) {
	return get('/upms/shop/guest/check_email', params, {
		headers: { noAuth: true }
	})
}

/**
 * Guest - 查询游客下单功能是否开启
 */
export function getGuestCheckoutEnabled() {
	return get('/upms/shop/guest/guest_checkout_enabled', {}, {
		headers: { noAuth: true }
	})
}

/**
 * Guest - 发送邮箱验证码
 */
export function sendVerifyCode(params) {
	return guestPost('/upms/shop/guest/send_verify_code', params)
}

/**
 * Guest - 通过验证码重置密码
 */
export function resetPassword(params) {
	return guestPost('/upms/shop/guest/reset_password', params)
}
